module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotGroupEditModal",
    attrs: {
      "id": "missionSlotTemplateSlotGroupEditModal",
      "title": _vm.$t('mission.modal.slotGroup.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotTemplateSlotGroupEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotTemplateSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotTemplateSlotGroupEditTitleState,
      "feedback": _vm.missionSlotTemplateSlotGroupEditTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupEditData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupEditData.title = $$v
      },
      expression: "missionSlotTemplateSlotGroupEditData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupEditData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupEditData.description = $$v
      },
      expression: "missionSlotTemplateSlotGroupEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotGroupEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupEditMoveAfter = $$v
      },
      expression: "missionSlotTemplateSlotGroupEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot group edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotGroupEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5286e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupEditModal.vue
// module id = 517
// module chunks = 0